import { createAction, props } from "@ngrx/store";

export const submitAdmissionDate = createAction(
    "[Admission date] Submit admission date",
    props<{ admissionDate: Date; contractId: number }>()
);
export const submitAdmissionDateSuccess = createAction(
    "[Admission date] Submit admission date success",
    props<{ data: Date }>()
);
export const submitAdmissionDateFailure = createAction(
    "[Admission date] Submit admission date failure"
);

export const getSysParams = createAction("[Admission date] Get params");
export const getSysParamsSuccess = createAction("[Admission date] Get params success");
export const getSysParamsFailure = createAction("[Admission date] Get params failure");

export const setMinDate = createAction("[Admission date] Set min date", props<{ data: Date }>());
export const setMaxDate = createAction("[Admission date] Set max date", props<{ data: Date }>());

export const resetAdmissionDate = createAction("[Admission date] Reset");